@let valueValue = value();
@let optionsValue = options();

@for (option of optionsValue; track option.value) {
  <div
    class="single-choice-field__option"
    [class.single-choice-field__option--selected]="valueValue === option.value"
    (click)="select(option.value)"
  >
    <rt-radio
      [hasAlignItemsStart]="!!option.description"
      [checked]="valueValue === option.value"
      (click)="$event.stopPropagation(); select(option.value)"
    >
      <div class="single-choice-field__option-content">
        <span
          class="single-choice-field__option-title"
          [class.single-choice-field__option-title--with-description]="!!option.description"
          >{{ option.label }}</span
        >
        @if (option.description) {
          <span class="single-choice-field__option-description">{{ option.description }}</span>
        }
      </div>
    </rt-radio>
  </div>
}
